import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "user-bind-dialog"
};
const _hoisted_2 = {
  class: "pagination-container"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
import { ref, reactive, watch } from "vue";
import { ElMessage } from "element-plus";
import { getAdminUserList, bindingUser } from "@/service/modules/organ";
export default /*@__PURE__*/_defineComponent({
  __name: 'user-bind-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    organId: {
      type: [String, Number],
      default: ""
    }
  },
  emits: ["update:dialogVisible", "success"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    // 添加正确的类型定义
    const userList = ref([]);
    const total = ref(0);
    const loading = ref(false);
    const submitting = ref(false);
    const selectedUsers = ref([]);
    // 查询参数
    const queryParams = reactive({
      current: 1,
      size: 10,
      keyword: ""
    });
    // 监听弹框打开
    watch(() => props.dialogVisible, val => {
      if (val) {
        getList();
      }
    });
    // 获取用户列表
    const getList = async () => {
      loading.value = true;
      const res = await getAdminUserList({
        ...queryParams
      });
      userList.value = res.data.records;
      total.value = Number(res.data.total);
      loading.value = false;
    };
    // 处理选择改变
    const handleSelectionChange = selection => {
      selectedUsers.value = selection;
    };
    // 处理页码改变
    const handleCurrentChange = val => {
      queryParams.current = val;
      getList();
    };
    // 处理每页条数改变
    const handleSizeChange = val => {
      queryParams.size = val;
      queryParams.current = 1;
      getList();
    };
    // 关闭弹框
    const handleClose = () => {
      emit("update:dialogVisible", false);
    };
    // 提交绑定
    const handleSubmit = () => {
      if (selectedUsers.value.length === 0) {
        ElMessage.warning("请选择要绑定的人员");
        return;
      }
      submitting.value = true;
      const userIds = selectedUsers.value.map(user => user.uid);
      let obj = {
        uid: userIds,
        organId: props.organId
      };
      console.log("绑定人员ID:", userIds, "到机构ID:");
      bindingUser(obj).then(res => {
        if (res.data) {
          ElMessage.success("绑定成功");
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        submitting.value = false;
      });
      emit("success", selectedUsers.value);
      emit("update:dialogVisible", false);
    };
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.$emit('update:dialogVisible', $event)),
        title: "绑定人员",
        width: "800px",
        onClose: handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("取 消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSubmit,
          loading: submitting.value
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode(" 确 定 ")])),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: userList.value,
          border: "",
          onSelectionChange: handleSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "55",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            prop: "uid",
            label: "id",
            width: "120"
          }), _createVNode(_component_el_table_column, {
            prop: "realName",
            label: "姓名",
            width: "120"
          }), _createVNode(_component_el_table_column, {
            prop: "username",
            label: "账号名称",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "mobile",
            label: "手机号",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "roleName",
            label: "角色"
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_pagination, {
          "current-page": queryParams.current,
          "page-size": queryParams.size,
          "page-sizes": [10, 20, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "total"])])])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
});